import { Platform, StyleSheet } from "react-native";

const interBold = Platform.select({
  ios: "Inter-Bold",
  android: "Inter-Bold",
  web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
  default: "Inter-Bold",
});

const interRegular = Platform.select({
  ios: "Inter-Regular",
  android: "Inter-Regular",
  web: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" as any,
  default: "Inter-Regular",
});

const styles = StyleSheet.create({
  screenRoot: {
    flex: 1,
    backgroundColor: "#f5f9ff",
  },
  container: {
    flex: 1,
    width: "100%",
    paddingHorizontal: 36,
    paddingTop: 24,
  },
  content: {
    flex: 1,
  },
  scrollContent: {
    paddingBottom: 36,
  },
  pageHeader: {
    minHeight: 56,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 16,
    gap: 16,
  },
  pageTitleBlock: {
    flex: 1,
    minWidth: 0,
  },
  breadcrumbRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    marginBottom: 4,
  },
  breadcrumbLink: {
    fontSize: 12,
    color: "#585858",
    fontWeight: "500",
    fontFamily: interRegular,
  },
  breadcrumbSeparator: {
    fontSize: 12,
    color: "#818181",
  },
  breadcrumbCurrent: {
    fontSize: 12,
    color: "#3a3a3a",
    fontWeight: "600",
    fontFamily: interBold,
  },
  pageTitle: {
    fontSize: 28,
    fontWeight: "700",
    color: "#2d2d2d",
    lineHeight: 34,
    fontFamily: interBold,
  },
  pageSubtitle: {
    fontSize: 13,
    color: "#818181",
    marginTop: 2,
    fontFamily: interRegular,
  },
  pageActions: {
    flexDirection: "row",
    gap: 8,
    alignItems: "center",
    flexShrink: 0,
  },
  btnGhost: {
    borderRadius: 100,
    paddingHorizontal: 18,
    paddingVertical: 9,
    backgroundColor: "transparent",
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  btnGhostPressed: {
    backgroundColor: "#e7effb",
  },
  btnGhostText: {
    fontSize: 13,
    fontWeight: "700",
    color: "#4b4b4b",
    fontFamily: interBold,
  },
  btnPrimary: {
    borderRadius: 100,
    paddingHorizontal: 18,
    paddingVertical: 9,
    backgroundColor: "#034895",
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  btnPrimaryPressed: {
    backgroundColor: "#01346f",
  },
  btnPrimaryText: {
    fontSize: 13,
    fontWeight: "700",
    color: "#ffffff",
    fontFamily: interBold,
  },
  statusSummary: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
    marginBottom: 16,
    paddingVertical: 12,
    paddingHorizontal: 14,
    backgroundColor: "#ffffff",
    borderRadius: 10,
    shadowColor: "#005EC0",
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.08,
    shadowRadius: 24,
    elevation: 2,
    alignItems: "center",
  },
  statusPill: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    backgroundColor: "#f8f8f8",
    borderWidth: 1,
    borderColor: "transparent",
    borderRadius: 100,
    paddingVertical: 6,
    paddingHorizontal: 12,
  },
  statusPillPressed: {
    backgroundColor: "#e7effb",
  },
  statusPillHovered: {
    backgroundColor: "#e7effb",
  },
  statusPillActive: {
    backgroundColor: "#034895",
    borderColor: "#034895",
  },
  statusDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
  },
  statusDotActive: {
    borderWidth: 2,
    borderColor: "rgba(255,255,255,0.5)",
  },
  statusPillLabel: {
    fontSize: 12,
    fontWeight: "600",
    color: "#4b4b4b",
    fontFamily: interRegular,
  },
  statusPillLabelActive: {
    color: "#ffffff",
  },
  statusPillCount: {
    minWidth: 20,
    borderRadius: 100,
    paddingHorizontal: 7,
    paddingVertical: 1,
    textAlign: "center",
    backgroundColor: "rgba(0,0,0,0.06)",
    fontSize: 11,
    fontWeight: "700",
    color: "#4b4b4b",
    fontFamily: interBold,
  },
  statusPillCountActive: {
    color: "#ffffff",
    backgroundColor: "rgba(255,255,255,0.22)",
  },
  dataTableWrap: {
    backgroundColor: "#ffffff",
    borderRadius: 8,
    shadowColor: "#005EC0",
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.08,
    shadowRadius: 24,
    elevation: 2,
    overflow: "hidden",
  },
  tableToolbar: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    paddingVertical: 14,
    paddingHorizontal: 20,
    borderBottomWidth: 1,
    borderBottomColor: "#ebebeb",
    flexWrap: "wrap",
  },
  searchWrap: {
    flex: 1,
    minWidth: 200,
    maxWidth: 320,
    position: "relative",
  },
  searchIcon: {
    position: "absolute",
    left: 12,
    top: 11,
    zIndex: 2,
  },
  searchInput: {
    width: "100%",
    height: 36,
    borderWidth: 1,
    borderColor: "#d0d0d0",
    borderRadius: 6,
    paddingLeft: 36,
    paddingRight: 12,
    fontSize: 13,
    color: "#2d2d2d",
    fontFamily: interRegular,
  },
  resultCount: {
    marginLeft: "auto",
    fontSize: 12,
    color: "#656565",
    fontWeight: "600",
    fontFamily: interBold,
  },
  tableMinWidth: {
    minWidth: 1540,
    width: "100%",
  },
  tableHeadRow: {
    flexDirection: "row",
    borderBottomWidth: 2,
    borderBottomColor: "#d7e5f8",
    backgroundColor: "#ffffff",
  },
  thCell: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    color: "#4b4b4b",
    fontSize: 12,
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: 0.5,
    fontFamily: interBold,
  },
  thSortable: {
    flexDirection: "row",
    alignItems: "center",
    gap: 2,
    ...Platform.select({ web: { cursor: "pointer" } as any }),
  },
  /** Wrapper for columns that have BOTH sort and filter controls */
  thSortFilterWrap: {
    flexDirection: "row",
    alignItems: "center",
    gap: 0,
    paddingHorizontal: 0,
    paddingVertical: 0,
  },
  /** Clickable sort area inside a sort+filter header (takes remaining width) */
  thSortArea: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    gap: 2,
    paddingHorizontal: 16,
    paddingVertical: 12,
    ...Platform.select({ web: { cursor: "pointer" } as any }),
  },
  /** Filter icon button inside a sort+filter header */
  thFilterIcon: {
    padding: 5,
    marginRight: 6,
    borderRadius: 4,
    alignItems: "center",
    justifyContent: "center",
    ...Platform.select({ web: { cursor: "pointer" } as any }),
  },
  /** Filter icon highlighted when this column has active filters */
  thFilterIconActive: {
    backgroundColor: "#EEF5FF",
  },
  /** "Action needed" pill shown below the status badge for waiting-user rows */
  actionNeededBadge: {
    flexDirection: "row",
    alignItems: "center",
    gap: 3,
    marginTop: 5,
    backgroundColor: "#FFF0E0",
    borderRadius: 12,
    paddingHorizontal: 6,
    paddingVertical: 3,
    alignSelf: "flex-start",
  },
  actionNeededText: {
    fontSize: 11,
    fontWeight: "600",
    color: "#A85100",
    fontFamily: interBold,
  },
  /** "View primary" link shown below the badge for closed-merged rows */
  mergedIntoRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 3,
    marginTop: 5,
    alignSelf: "flex-start",
  },
  mergedIntoLink: {
    fontSize: 11,
    fontWeight: "600",
    color: "#7871E2",
    textDecorationLine: "underline",
    fontFamily: interBold,
  },
  thCellText: {
    fontSize: 12,
    fontWeight: "700",
    color: "#4b4b4b",
    textTransform: "uppercase",
    letterSpacing: 0.5,
    fontFamily: interBold,
  },
  thCellTextActive: {
    color: "#034895",
  },
  sortArrows: {
    flexDirection: "column",
    alignItems: "center",
    marginLeft: 2,
  },
  tableBodyRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#ebebeb",
    backgroundColor: "#ffffff",
    alignItems: "center",
    ...Platform.select({
      web: {
        cursor: "pointer",
        transitionProperty: "background",
        transitionDuration: "120ms",
      } as any,
    }),
  },
  tableBodyRowHovered: {
    backgroundColor: "#F3F7FD",
  },
  tableBodyRowPressed: {
    backgroundColor: "#f3f7fd",
  },
  tableBodyRowWaitingUser: {
    borderLeftWidth: 3,
    borderLeftColor: "#FF8C09",
    backgroundColor: "#fff5ec",
    ...Platform.select({
      web: {
        backgroundImage: "linear-gradient(90deg, #FFF5EC 0%, transparent 40%)",
      } as any,
    }),
  },
  tableBodyRowWaitingUserHovered: {
    backgroundColor: "#FFE9D1",
    ...Platform.select({
      web: {
        backgroundImage: "linear-gradient(90deg, #FFE9D1 0%, #F3F7FD 60%)",
      } as any,
    }),
  },
  tdCell: {
    paddingHorizontal: 16,
    paddingVertical: 14,
    color: "#3a3a3a",
    fontSize: 13,
    fontFamily: interRegular,
  },
  tdCellWrap: {
    paddingHorizontal: 16,
    paddingVertical: 14,
  },
  tdId: {
    fontSize: 12,
    color: "#005cbc",
    fontWeight: "700",
    fontFamily: interBold,
  },
  tdTitle: {
    fontWeight: "600",
    color: "#2d2d2d",
    fontFamily: interBold,
  },
  tdDate: {
    fontSize: 12,
    color: "#585858",
  },
  sapIdText: {
    marginTop: 2,
    fontSize: 11,
    color: "#656565",
    fontFamily: interRegular,
  },
  colId: { width: 140 },
  colTitle: { width: 300 },
  colCategory: { width: 140 },
  colSubCategory: { width: 150 },
  colLocation: { width: 200 },
  colUrgency: { width: 130 },
  colStatus: { width: 170 },
  colDate: { width: 155 },
  tdSubCategory: {
    fontSize: 12,
    color: "#585858",
  },
  levelPill: {
    marginTop: 3,
    alignSelf: "flex-start",
    backgroundColor: "#EFF6FF",
    borderRadius: 100,
    paddingHorizontal: 8,
    paddingVertical: 2,
  },
  levelPillText: {
    fontSize: 11,
    fontWeight: "600",
    color: "#1D4ED8",
    fontFamily: interBold,
  },
  filterBar: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 8,
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderBottomWidth: 1,
    borderBottomColor: "#ebebeb",
    backgroundColor: "#FAFCFF",
  },
  filterChip: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    paddingVertical: 5,
    paddingHorizontal: 12,
    borderRadius: 100,
    borderWidth: 1,
    borderColor: "#d0d0d0",
    backgroundColor: "#ffffff",
    ...Platform.select({ web: { cursor: "pointer" } as any }),
  },
  filterChipActive: {
    borderColor: "#034895",
    backgroundColor: "#EFF6FF",
  },
  filterChipText: {
    fontSize: 12,
    fontWeight: "600",
    color: "#4b4b4b",
    fontFamily: interBold,
  },
  filterChipTextActive: {
    color: "#034895",
  },
  clearFiltersBtn: {
    paddingVertical: 5,
    paddingHorizontal: 10,
    ...Platform.select({ web: { cursor: "pointer" } as any }),
  },
  clearFiltersBtnText: {
    fontSize: 12,
    fontWeight: "600",
    color: "#CC3B0F",
    fontFamily: interBold,
  },
  badge: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 100,
    alignSelf: "flex-start",
  },
  badgeDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
  },
  badgeText: {
    fontSize: 12,
    fontWeight: "700",
    color: "#4b4b4b",
    fontFamily: interBold,
  },
  // Urgency badges — bg + dot + text colors match HTML
  urgencyCritical: { backgroundColor: "#FFE5DE" },
  urgencyCriticalDot: { backgroundColor: "#C12C01" },
  urgencyCriticalText: { color: "#C12C01" },
  urgencyHigh: { backgroundColor: "#FFE9D1" },
  urgencyHighDot: { backgroundColor: "#CC6E16" },
  urgencyHighText: { color: "#CC6E16" },
  urgencyMedium: { backgroundColor: "#FEF1B9" },
  urgencyMediumDot: { backgroundColor: "#8B6508" },
  urgencyMediumText: { color: "#8B6508" },
  urgencyLow: { backgroundColor: "#EBEBEB" },
  urgencyLowDot: { backgroundColor: "#585858" },
  urgencyLowText: { color: "#585858" },
  // Status badges — bg + dot + text colors match HTML
  statusInProgress: { backgroundColor: "#E1E3FD" },
  statusInProgressDot: { backgroundColor: "#7871E2" },
  statusInProgressText: { color: "#7871E2" },
  statusWaitingonIT: { backgroundColor: "#FEF1B9" },
  statusWaitingonITDot: { backgroundColor: "#8B6508" },
  statusWaitingonITText: { color: "#8B6508" },
  statusEscalatedtoIT: { backgroundColor: "#FEF1B9" },
  statusEscalatedtoITDot: { backgroundColor: "#8B6508" },
  statusEscalatedtoITText: { color: "#8B6508" },
  statusWaitingonUser: { backgroundColor: "#FFE9D1" },
  statusWaitingonUserDot: { backgroundColor: "#CC6E16" },
  statusWaitingonUserText: { color: "#CC6E16" },
  statusWaitingonTMV: { backgroundColor: "#AAD2E2" },
  statusWaitingonTMVDot: { backgroundColor: "#0078A7" },
  statusWaitingonTMVText: { color: "#0078A7" },
  statusEscalatedtoTMV: { backgroundColor: "#AAD2E2" },
  statusEscalatedtoTMVDot: { backgroundColor: "#0078A7" },
  statusEscalatedtoTMVText: { color: "#0078A7" },
  statusSubmittedtoADO: { backgroundColor: "#DCD5FB" },
  statusSubmittedtoADODot: { backgroundColor: "#5C4EC9" },
  statusSubmittedtoADOText: { color: "#5C4EC9" },
  statusClosed: { backgroundColor: "#DDF9DA" },
  statusClosedDot: { backgroundColor: "#027C06" },
  statusClosedText: { color: "#027C06" },
  statusClosedMerged: { backgroundColor: "#E9E9E9" },
  statusClosedMergedDot: { backgroundColor: "#6B7280" },
  statusClosedMergedText: { color: "#6B7280" },
  statusNew: { backgroundColor: "#DAEEFA" },
  statusNewDot: { backgroundColor: "#034895" },
  statusNewText: { color: "#034895" },
  pagination: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderTopWidth: 1,
    borderTopColor: "#ebebeb",
  },
  paginationText: {
    fontSize: 12,
    color: "#585858",
    fontFamily: interRegular,
  },
  paginationGroup: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  pgButtonDisabled: {
    width: 32,
    height: 32,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: "#d0d0d0",
    alignItems: "center",
    justifyContent: "center",
    opacity: 0.5,
  },
  pgButton: {
    width: 32,
    height: 32,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: "#034895",
    alignItems: "center",
    justifyContent: "center",
  },
  pgButtonText: {
    color: "#034895",
    fontSize: 12,
    fontWeight: "600",
    fontFamily: interRegular,
  },
  pgButtonActive: {
    width: 32,
    height: 32,
    borderRadius: 6,
    backgroundColor: "#034895",
    alignItems: "center",
    justifyContent: "center",
  },
  pgButtonActiveText: {
    color: "#ffffff",
    fontSize: 12,
    fontWeight: "700",
    fontFamily: interBold,
  },
});

export default styles;
